import layout from './layout';
import trips from './trips';
import suppliers from './suppliers';
import automations from './automations';
import rates from './rates';
import vehicles from './vehicles';
import drivers from './drivers';
import driverShifts from './driverShifts';
import jobs from './jobs';
import passengers from './passengers';
import performanceDashboard from './performanceDashboard';

const index = {
  layout,
  trips,
  suppliers,
  automations,
  rates,
  vehicles,
  drivers,
  driverShifts,
  jobs,
  passengers,
  performanceDashboard,
};

export default index;
